import { IReviewEntity } from '@/entities';
import { AppConstants as _app} from '@/shared/app.constants';
import { IMutations } from './mutations.types';
// const temp = require('../dd_assessment_template_en.json');

export const mutations: IMutations = {
    setSelectedApplication(state: IReviewEntity, payload: number): void {
        state.applicationId = payload
    },
    setSelectedReview(state: IReviewEntity, payload: number) {
        state.externalReviewId = payload
    }
}